import { serviceHost } from "../../common/const";
import ServiceRequest from "../../utils/service-request";

export const getAllUserRoles = async () => {
  try {
    let response = await ServiceRequest(
      "get",
      "json",
      serviceHost + "/userRoles"
    );
    return { response, err: null };
  } catch (err) {
    if (err) {
      return { response: null, err };
    }
  }
};

export const getActiveUsers = async () => {
  try {
    let response = await ServiceRequest(
      "post",
      "json",
      serviceHost + "/admin/getActiveUsers"
    );
    return { response, err: null };
  } catch (err) {
    if (err) {
      return { response: null, err };
    }
  }
};

export const getAllInternalUsers = async (id) => {
  try {
    let response = await ServiceRequest(
      "post",
      "json",
      serviceHost + "/admin/getAllInternalUsers"
    );
    return { response, err: null };
  } catch (err) {
    if (err) {
      return { response: null, err };
    }
  }
};

export const getUser = async (data) => {
  try {
    let response = await ServiceRequest(
      "post",
      "json",
      serviceHost + "/admin/getUser",
      data
    );
    return { response, err: null };
  } catch (err) {
    if (err) {
      return { response: null, err };
    }
  }
};

export const genrateCustCode = async (data) => {
  try {
    let response = await ServiceRequest(
      "post",
      "json",
      serviceHost + "/client/genrateCustCode/",
      data
    );
    return { response, err: null };
  } catch (err) {
    if (err) {
      return { response: null, err };
    }
  }
};

export const isExistCustCode = async (data) => {
  try {
    let response = await ServiceRequest(
      "post",
      "json",
      serviceHost + "/client/isExistCustCode/",
      data
    );
    return { response, err: null };
  } catch (err) {
    if (err) {
      return { response: null, err };
    }
  }
};
export const updateInternalUser = async (user) => {
  try {
    let response = await ServiceRequest(
      "post",
      "json",
      serviceHost + "/admin/updateInternalUser",
      user
    );
    return { response, err: null };
  } catch (err) {
    if (err) {
      return { response: null, err };
    }
  }
};

export const createInternalUser = async (user) => {
  try {
    let response = await ServiceRequest(
      "post",
      "json",
      serviceHost + "/admin/createInternalUser",
      user
    );
    return { response, err: null };
  } catch (err) {
    if (err) {
      return { response: null, err };
    }
  }
};

export const deleteUser = async (id) => {
  try {
    let response = await ServiceRequest(
      "post",
      "json",
      serviceHost + "/admin/deleteUser/" + id
    );
    return { response, err: null };
  } catch (err) {
    if (err) {
      return { response: null, err };
    }
  }
};
